import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../helpers/global";
import { fetchOrders } from "../helpers/orders";
import { List } from "../../components/List";
import { ListPagination } from "../../components/List/Pagination";
import { Message } from "../../components/Message";
import { fetchContacts } from "../helpers/customer";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppOrdersOverview({ current, setFilterFields, filterValues, identifier }) {

    let pageSize = 10; // default values ergens globaal opslaan?

    const [orders, setOrders] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(getCurrentPage(current));
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState("{}");

    if (JSON.stringify(filterValues) !== filterString) {


        console.info(filterValues);

        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, current, setPageNr);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
    }

    let listColumns = [
        { key: "displayName", label: "Type", type: "text" },
        { key: "customerReference", label: "Referentie", type: "text"},
        { key: "status", label: "Status", type: "text" },
        { key: "orderDate", label: "Orderdatum", type: "date" },
        { key: "displayLocation", label: "Locatie", type: "text" },
        { key: "orderId", type: "link", path: "details/:orderId", hideView: "small" },
    ];

    const defineFilterFields = (contacts) => {

        // The filters are set here and send to parent onloaded
        let filterFields = {
            'location': { type: 'location', options: { locationId: "locationId" }, label: { locationId: "Locatie" } },
            'customerReference' : { type: 'text', label: "Klantreferentie"},
        };

        setFilterFields(filterFields);
    }

    useEffect(() => {

        async function fetchData() {

            var context = 'OPEN';
            if(current === 'quotations') {
                context = 'QUOTATION';
            }
            else if(current === 'completed') {
                context = 'COMPLETED';
            }

            const callData = {
                filters: {
                    tabType: current,
                    limitOffset: pageSize * pageNr - (pageSize - 1),
                    limitRows: pageSize,
                    context: context,
                    ...filters
                }
            }

            await fetchContacts(callData).then((res) => {
                const response = ValidateResponse(res.data, 'contacts');
                if (response.status === 'success') {
                   // setContacts(response.contacts);
                                            
                    if (loadFilters !== current) {
                        defineFilterFields(response.contacts);
                        setLoadFilters(current);
                    }
                }
            });

            await fetchOrders(callData).then((res) => {

                const response = ValidateResponse(res.data, 'results');
                if (response.status === 'success') {

                    if (response.totalCount !== undefined) {
                        setTotalCount(response.totalCount);
                        
                        if (loadFilters !== current) {
                            setLoadFilters(current);
                        }
                    }
                    setOrders(response.results);
                    setIsLoaded(true);
                }
                else {
                    setError(response.message);
                }
            }).catch((error) => {
                const response = ValidateResponse(error);
                setError(response.message);
            });
        }

        fetchData();
    }, [current, pageNr, filters, filterString, pageSize]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (orders === undefined || orders === null || Object.keys(orders).length === 0) {
        return (<Message type="noData" />);
    }

    return (
        <>
            <List
                columns={listColumns}
                data={orders}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                setCurrentPage={handlePagination}
                totalCount={totalCount}
                pageSize={pageSize}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}